import jwtAxios from '@tenant/services/auth/jwt-auth';

export const DOCKER_IMAGE_APIS = {
  ROOT: 'api/docker-images',
  GROUP_BY_NAME: 'api/docker-images/group-by-name',
  REPOSITORY_AVAILABLE: 'api/docker-repositories/:repository/exists',
  VERSION: 'api/docker-repositories/:repository/versions',
  LAST_RUN: 'api/docker-repositories/:repository/lastrun',
  LOGS: 'api/docker-repositories/:lastRunId/logs',
};

export const getListDockerImageQuery = (params) => {
  return jwtAxios.get(DOCKER_IMAGE_APIS.ROOT, { params });
};

export const getAvailableDockerImageQuery = (repository) => {
  return (
    repository &&
    jwtAxios.get(
      DOCKER_IMAGE_APIS.REPOSITORY_AVAILABLE.replace(':repository', repository),
    )
  );
};

export const getListGroupByNameDockerImageQuery = () => {
  return jwtAxios.get(DOCKER_IMAGE_APIS.GROUP_BY_NAME);
};

export const addDockerImageQuery = (payload) => {
  return jwtAxios.post(DOCKER_IMAGE_APIS.ROOT, payload);
};

export const deleteDockerImageQuery = (payload) => {
  return jwtAxios.delete(DOCKER_IMAGE_APIS.ROOT + '/' + payload?.Name);
};

export const getListDockerVersionQuery = (params) => {
  return jwtAxios.get(
    DOCKER_IMAGE_APIS.VERSION.replace(':repository', params?.repository),
    { params },
  );
};

export const getLastRunRepositoryQuery = (params) => {
  return jwtAxios.get(
    DOCKER_IMAGE_APIS.LAST_RUN.replace(':repository', params?.repository),
  );
};

export const getLogRepositoryQuery = (params) => {
  return jwtAxios.get(
    DOCKER_IMAGE_APIS.LOGS.replace(':lastRunId', params?.lastRunId),
  );
};
